import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=6b5f2fdf&scoped=true"
import script from "./FormData.vue?vue&type=script&lang=js"
export * from "./FormData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f2fdf",
  null
  
)

export default component.exports